package io.jsonize.web.services

interface FileExport {
    fun downloadJson(filename: String, content: String)

    companion object {
        // Provided for easy default wiring in shared ViewModel
        lateinit var default: FileExport
    }
}
